import { RenderToast } from './druid/types/ToastMiddleware';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useRenderToast(): RenderToast {
  return useWebChatAPIContext().toastRenderer;
}
